import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ReportManagementService } from './report-management.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-report-management',
  templateUrl: './report-management.component.html',
  styleUrls: ['./report-management.component.scss']
})
export class ReportManagementComponent implements OnInit {
  allReport: any;
  reportList: any;
  page: number = 1;
  pageSize: number = 10;
  collectionSize: number;
  rows: any[];
  search: string;
  isSearch: boolean = false;
  searchReport: any = '';
  locationUrl: string = window.location.origin;
  alwaysOpen: boolean = true;

  sortIdFn = (a, b) => ('' + a.REPORT_ID).localeCompare(b.REPORT_ID);
  viewStatusFilterFn = (list: string[], item) => list.some(status => item.IS_VIEW === status);
  filterReportTypeFn = (list: string[], item) => list.some(status => item.STATUS.indexOf(status) !== -1);

  reportTypeFilter = [
    { text: 'รายงานผลเบื้องต้น', value: 'free' },
    { text: 'รายงานผลเชิงลึก', value: 'paid' },
    { text: 'รายงานผลเบื้องต้น/รายงานผลเชิงลึก', value: 'both' },
    { text: 'ยังไม่มีรายงานผล', value: 'not' },
  ];
  filterViewStatus = [
    { text: 'เปิด', value: 0 },
    { text: 'ปิด', value: 1 }
  ];

  constructor(
    public matDialog: MatDialog,
    private reportManagementService: ReportManagementService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.getAllReport();
    this.gobalFunctionService.setTitle('การจัดการรายงานผล');
  }

  addReport() {
    window.open('/report-management/manage-report?isEdit=false', '_blank');
  }

  searching() {
    if (this.search !== '') {
      this.isSearch = true;
      this.searchReport = [];
      this.allReport.filter(report => {
        if (report.MEASURE_NAME.toLowerCase().includes(this.search.toLowerCase()) || report.REPORT_NAME.toLowerCase().includes(this.search.toLowerCase()) || report.REPORT_ID.toLowerCase().includes(this.search.toLowerCase())) {
          this.searchReport.push(report)
        }
      });
    } else {
      this.isSearch = false
      this.searchReport = null;
      this.getAllReport();
    }
  }

  getAllReport() {
    this.reportManagementService.getAllDashBoardReport().subscribe(res => {
      // console.log(res);

      this.reportList = res.result;

      this.allReport = this.reportList.map(el => {
        return {
          REPORT_ID: el.REPORT_ID,
          REPORT_NAME: el.REPORT_NAME,
          MEASURE_NAME: el.MEASURE_NAME,
          CREATE_DATE: el.CREATE_DATE,
          STATUS: (el.STATUS_FREE === 'true' && el.STATUS_NOTFREE === 'true') ? 'both' : (el.STATUS_FREE === 'true' && el.STATUS_NOTFREE === 'false') ? 'free' : (el.STATUS_FREE === 'false' && el.STATUS_NOTFREE === 'true') ? 'paid' : (el.STATUS_FREE === 'false' && el.STATUS_NOTFREE === 'false') ? 'not' : '',
          IS_VIEW: el.IS_VIEW,
        }
      })
    })
  }

  changeStatus(event, report) {
    const dialogConfig = new MatDialogConfig();
    let body;

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';

    // console.log(report);


    if (report.IS_VIEW) {
      dialogConfig.data = {
        title: 'คุณต้องการเปลี่ยนสถานะการมองเห็น?',
        description: 'คุณต้องการเปิดสถานะการมองเห็น ผู้ใช้จะสามารถเห็นรายงานผลได้',
        actionBtnText: 'ยืนยัน',
        cancleBtnText: 'ยกเลิก'
      }
      body = {
        REPORT_ID: report.REPORT_ID,
        IS_VIEW: 0
      }
    } else {
      dialogConfig.data = {
        title: 'คุณต้องการเปลี่ยนสถานะการมองเห็น?',
        description: 'คุณต้องการปิดสถานะการมองเห็น ผู้ใช้จะไม่สามารถเห็นรายงานผลได้',
        actionBtnText: 'ยืนยัน',
        cancleBtnText: 'ยกเลิก'
      }
      body = {
        REPORT_ID: report.REPORT_ID,
        IS_VIEW: 1
      }
    }

    // console.log(body);

    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    modal.afterClosed().subscribe(res => {
      if (res) {
        this.reportManagementService.updateStatusViewByReport(body).pipe(
          map((res2) => {
            // console.log(res2);

            event.source.checked = report.IS_VIEW;
            this.getAllReport();
          })
        ).subscribe();
      } else {
        event.source.checked = !report.IS_VIEW;
      }
    })
  }

  edit(row) {
    window.open('/report-management/manage-report?isEdit=true&report_id=' + row.REPORT_ID, '_blank')
  }
}
